// extracted by mini-css-extract-plugin
export var icon = "_a0-3";
export var subtitle = "_a0-2";
export var title = "_a0-1";
export var value = "_a0-0";